export default "__VITE_ASSET__CfgwO5dj__"